<div class="text-center">
  <h2 class="mt-4">Thank you, We'have sent the request.</h2>
  <h5 class="mt-4 text-success">We have extended your trial for <strong>1 day</strong>.</h5>
  <h6 class="mt-2"> You can now login with same username and password.</h6>
  <button class="btn page-btn mt-4 mb-3 pe-auto"(click)="extend()">Okay</button>
</div>
